import React, { Component } from 'react';
import { Layout } from './components/Layout';
import "carbon-components/css/carbon-components.css";

import './style/App.scss'

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout></Layout>
    );
  }
}
